import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  Injector,
  Input,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenuService } from 'src/app/core/services/menu.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { GlobalConstants } from 'src/app/core/constants/global-constants.constant';
import { Router } from '@angular/router';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'laas-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent
  extends SessionBaseComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  showItems: MenuItem[] = [];
  sideItems: MenuItem[] = [];
  favoriteItems: MenuItem[] = [];
  menuTabs: MenuItem[] = [];
  activeTabItem: MenuItem;
  searchKeyword: string = '';
  recentMenus: any[] = [];
  filteredMenus: any[] = [];
  allFlatMenus: any[] = [];
  showPanel = false;
  highlightedIndex: number = -1;
  debounceTimer: any;
  selectedMenu: any = null;
  userUuid: string;
  activeTab: string = 'favorite';


  constructor(
    injector: Injector,
    private router: Router,
    public menuDataService: MenuService,
  ) {
    super(injector);
    this.userUuid = '';

    this.menuTabs = [
      {
        label: this.laasSetting.language == 'zh-tw' ? '我的最愛' : 'Favorite',
        id: 'favorite',
      },
      {
        label: this.laasSetting.language == 'zh-tw' ? '所有功能' : 'All',
        id: 'side',
      },
    ];
    this.activeTabItem = this.menuTabs[0];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.userUuid = this.userProfile?.uuid;

    if (window.innerWidth <= 667) {
      this.menuDataService.toggleMenuBar.next(false);
    }
    console.log(this.userUuid);
    this.menuDataService
      .getMenuDataByPosition('Side', this.userUuid)
      .subscribe({
        next: (sideMenuItems) => {
          this.sideItems = this.convertToMenuItems(sideMenuItems);
        },
      });

    this.menuDataService
      .getMenuDataByPosition('Favorite', this.userUuid)
      .subscribe({
        next: (favoriteMenuItems) => {
          this.favoriteItems = this.convertToMenuItems(favoriteMenuItems);
          this.showItems = this.favoriteItems;
        },
      });

    /* 添加這段代碼來監聽螢幕寬度變化 */
    this.menuDataService.isRwd.subscribe((result) => {
        this.menuDataService.toggleMenuBar.next(!result);
    });
  }

  onHideMenu(): void {
    // this.isVisible = false;
  }

  ngOnDestroy(): void {
    this.menuDataService
      .getMenuDataByPosition('Side', this.userUuid)
      .subscribe({
        next: (sideMenus) => {
          sideMenus.forEach((el: { complete: () => any }) => el.complete());
        },
      });
  }

  private convertToMenuItems(beans: any[]): MenuItem[] {
    return beans.map((bean) => this.convertToMenuItem(bean));
  }

  private convertToMenuItem(bean: any): MenuItem {
    const label = this.getMenuLabelByLanguage(bean, this.laasSetting.language);
    const menuItem: MenuItem = {
      label,
      icon: GlobalConstants.menuIconMap.get(bean.icon),
      items: [],
      routerLink: bean.routerLink,
      url: bean.url,
      target: bean.url ? '_blank' : undefined,
      command: () => {
        if(bean.url || bean.routerLink) {
          this.routeStateService.clear();
          if (this.menuDataService.isRwd.value) {
            this.menuDataService.toggleMenuBar.next(false);
          }
        }
      },
    };

    if (bean.items && bean.items.length > 0) {
      menuItem.items = this.convertToMenuItems(bean.items);
    }

    return menuItem;
  }

  private getMenuLabelByLanguage(menu: any, lang: string): string {
    const normalizedLang = lang?.toLowerCase();
    switch (normalizedLang) {
      case 'en-us':
        return menu.nodeNameEN || '';
      case 'zh-tw':
        return menu.nodeNameTW || '';
      default:
        return '';
    }
  }

  onTabChange(selectedTab: MenuItem) {
    if (!isNullOrEmpty(this.userUuid)) {
      this.switchTab(selectedTab.id!);
    }
  }

  switchTab(type: string) {
    if (type === 'favorite') {
      if (this.favoriteItems.length > 0) {
        this.showItems = this.favoriteItems;
      } else {
        this.menuDataService
          .getMenuDataByPosition('favorite', this.userUuid)
          .subscribe((res) => {
            this.favoriteItems = this.convertToMenuItems(res);
            this.showItems = this.favoriteItems;
          });
      }
    } else {
      if (this.sideItems.length > 0) {
        this.showItems = this.sideItems;
      } else {
        this.menuDataService
          .getMenuDataByPosition('Side', this.userUuid)
          .subscribe((res) => {
            this.sideItems = this.convertToMenuItems(res);
            this.showItems = this.sideItems;
          });
      }
    }
  }
}
